import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import icLock from "./ic_lock.svg";
import "./style.scss";

export default class SendOtpSecure extends React.Component {
  static propTypes = {
    maskedPhoneNumber: PropTypes.number,
    code: PropTypes.string,
    status: PropTypes.string,
    isDesktopView: PropTypes.bool,
    isHidden: PropTypes.bool,
    bottomOffset: PropTypes.number,
    className: PropTypes.string,
  };

  getTitle = () => {
    const isPickup = this.props.status === "driver-found";
    const isDropOff = this.props.status === "picked-up";

    if (isPickup && this.props.maskedPhoneNumber) {
      return (
        <FormattedMessage
          id="GoSend.OTPSecure.titleWithMaskedPhone"
          values={{ maskedPhoneNumber: <strong className="otp-secure__highlight">{this.props.maskedPhoneNumber}</strong> }}
        />
      );
    } else if (isDropOff && this.props.code) {
      return (
        <FormattedMessage
          id="GoSend.OTPSecure.title"
          values={{
            code: <strong className="otp-secure__code">{this.props.code}</strong>,
            only: (
              <strong className="otp-secure__highlight">
                <FormattedMessage id="GoSend.OTPSecure.only" defaultMessage="only" />
              </strong>
            ),
          }}
        />
      );
    }
  }

  render() {
    const {
      maskedPhoneNumber,
      code,
      status,
      isDesktopView = false,
      isHidden = false,
      bottomOffset = 0,
      className = "",
    } = this.props;

    if (!maskedPhoneNumber || !code || isHidden) return null;

    const containerClass = [
      "otp-secure",
      isDesktopView ? "otp-secure--inline" : "otp-secure--floating",
      className,
    ].join(" ");

    const floatingStyle = isDesktopView ? undefined : { bottom: bottomOffset };

    return (
      <div
        className={containerClass}
        style={floatingStyle}
        role="status"
        aria-live="polite"
      >
        <img src={icLock} alt="" className="otp-secure__icon" />
        <div className="otp-secure__text">
          {this.getTitle()}
        </div>
      </div>
    );
  }
}
